
const changeAccountUseCase = (repository) => async (id, data) => {
    return await repository(id, data);
}

export default changeAccountUseCase;

